import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import addbutton from "../static/images/add-button.png";
import ReactPlayer from "react-player";
import $ from "jquery";

const GaleriaVideos = ({ data, reload, edit }) => {
  const [empty, setEmpty] = useState(true);
  const [selectVideo, setselectVideo] = useState("");

  useEffect(() => {
    setEmpty(data?.length == 0);
  }, [data]);

  function FindVideo(id) {
    setselectVideo(data.find((i) => i.companyVideoId === id));
  }

  function DeleteVideo() {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .post("company-video/delete/" + selectVideo.companyVideoId, config)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          $("#eliminar-video-modal").modal("hide");
          reload();
        }
      })
      .catch(function (error) {
        $("#eliminar-video-modal").modal("hide");
      });
  }

  function UpdateVideo(values) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    const video = {
      companyId: selectVideo.companyId,
      companyVideoId: selectVideo.companyVideoId,
      description: values.description,
      url: values.url,
    };

    axios
      .post("company-video/update", JSON.stringify(video), config)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          //setLoading(true);
          //GetVideos();
          reload();
          $("#update-video-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#update-video-modal").modal("hide");
      });
  }

  const Validaciones = Yup.object().shape({
    url: Yup.string()
      .required("No puede estar vacío")
      .max(60, "No puede tener más de 60 caracteres"),
    description: Yup.string()
      .required("No puede estar vacío")
      .min(3, "No puede tener menos de 3 caracteres"),
  });

  return (
    <Fragment>
      {empty ? (
        <label className="login-label">
          Todavía no ha cargado ningún video.
        </label>
      ) : (
        <div className="col-12">
          <div className="row mt-2">
            {data.map((item, index) => {
              return (
                <div key={index} className="col-xs-12 col-md-6">
                  <div className="mb-6">
                    <ReactPlayer
                      url={item.url}
                      controls={true}
                      config={{
                        youtube: {
                          playerVars: { showinfo: 1 },
                        },
                        facebook: {
                          appId: "12345",
                        },
                      }}
                      className="react-player"
                      height="200px"
                      width="100%"
                    />
                    <span>{item.description}</span>
                  </div>
                  {edit ? (
                    <div className="col-xs-2 col-md-2 mb-2">
                      <div className="toolset" style={{ width: "100px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <a
                            href="#"
                            className="edit-button"
                            data-bs-toggle="modal"
                            data-bs-target="#update-video-modal"
                            onClick={() => FindVideo(item.companyVideoId)}
                          ></a>
                          <a
                            href="#"
                            className="delete-button"
                            data-bs-toggle="modal"
                            data-bs-target="#eliminar-video-modal"
                            onClick={() => FindVideo(item.companyVideoId)}
                          ></a>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div
        id="update-video-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  description: selectVideo.description,
                  url: selectVideo.url,
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  UpdateVideo(values);
                  resetForm(true);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="mb-4 row">
                      <label htmlFor="url" className="col-sm-2 pe-0">
                        URL Video:
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="url"
                          name="url"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.url && touched.url && (
                          <span className="form__validation form__validation--error">
                            {errors.url}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="description" className="col-sm-2 pe-0">
                        Descripción:
                      </label>
                      <div className="col-sm-10">
                        <Field
                          as="textarea"
                          id="description"
                          name="description"
                          //type="textarea"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.description && touched.description && (
                          <span className="form__validation form__validation--error">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--gradient "
                      >
                        Subir
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div
        id="eliminar-video-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">Eliminar Video</div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeleteVideo()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default GaleriaVideos;
